import React from 'react';
import { inject } from 'mobx-react';
import styled from 'styled-components';

import { institutionLogoWidth } from 'js/config/style';
import Icon from 'js/components/common/Icon';

const Image = styled.img`
  max-width: 100%;
`;

const BankIcon = styled(Icon).attrs({ name: 'university' })`
  font-size: 2.5rem;
`;

const LogoContainer = styled.div`
  width: ${institutionLogoWidth};
  align-self: center;
  justify-self: center;
  text-align: center;
`;

export default inject('bankAccount')(({ bankAccount }) => (
  <LogoContainer>
    {bankAccount.logo_src ? (
      bankAccount.institution_url ? (
        <a target="_blank" href={bankAccount.institution_url}>
          <Image src={bankAccount.logo_src} />
        </a>
      ) : (
        <Image src={bankAccount.logo_src} />
      )
    ) : (
      <BankIcon />
    )}
  </LogoContainer>
));
